<template>
  <div id='appbind' class=''>
    <tyc :tqobj='tqobj'></tyc>
    <!-- <div v-show='isAppBatch' class='gPageBorder gTopMg'  style='width:100%;'>
      <p class='gCtColor  gPTitle' style=''>{{$t('menu.terManageSub.appList')}} </p>
      <div id='' style="width:100%;">
        <el-table
          :data="info.data"
          border
          class=''
          style="width: 100%;border:none;">
        
          <el-table-column
            header-align='center'
            align='center'
            prop="appName"
            :label="$t('app_appName')"
            width="">
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="appSize"
            width=''
            :label="$t('app_fileSize')">
            <template slot-scope='scope'>
              <label>{{(scope.row.appSize/1000000).toFixed(2)}} MB</label>
            </template>
          </el-table-column>
        

          <el-table-column
            header-align='center'
            align='center'
            prop="appVersion"
            width=''
            :label="$t('app_version')">
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="createTime"
            width='175'
            
            :label="$t('app_ulTime')">
          </el-table-column>

        </el-table>

      </div>
    </div> -->

    <el-button v-show='!isAppBatch' type='primary' @click='pushedList = true' style="margin-bottom:20px;margin-top:5px;">{{$t('app_pusheddvlist')}}</el-button>

    <el-dialog class='gDia' :title="$t('app_pushDevice')" v-model="pushedList" @open=open @close='close' size='large'>
      <div id='' class=' '>
    
        

        <el-row>
          <el-col :span="4">
            <el-button class='gSgLeftBtn' v-show="info.type === '10'" @click='allUnbind()' style=''>{{$t('app_bcrecov')}} ({{sNum}})</el-button>

            <el-button v-show="info.type === '1'" @click='mulDelAppPush()' style=''>{{$t('app_mulUnbind')}} ({{sNum}})</el-button>

            <el-button v-show="true" @click='refreshBind()' style=''>{{$t('lin_global.shuaxin')}}</el-button>
          </el-col>
          <el-col v-show='false' :offset="16" :span="4">
            <div class=''><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
          </el-col>
        </el-row>
      
        <el-table
        class='gTopMg'
        ref="multipleTable"
        id='dpTable'
        :data="tableData"
        border
        
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
          <el-table-column
            
            type="selection"
            align='center'
            width="55">
          </el-table-column>
          <el-table-column
            
            prop="terminalName"
            align='center'
            :label="$t('app_deviceName')"
            width="">
          </el-table-column>
          <el-table-column
            align='center'
            prop="terminalNo"
            :label="$t('app_deviceNo')"
            width="">
          </el-table-column>
          <el-table-column
            prop="pushTime"
            align='center'
            :label="$t('app_pushTime')"
            width='175'>
          </el-table-column>
          <el-table-column
            align='center'
            prop="mechName"
            :label="$t('app_distributor')"
            width=''>
          </el-table-column>
          
          <el-table-column
            prop="operate"
            :label="$t('app_operate')"
            align='center'
            
            width='106'>
            <template slot-scope='scope'>
              
              

              <el-tooltip v-show="info.type === '10'" class="item" effect="dark" :content="$t('app_recov')" placement="top">
                <el-button  @click='bindOperate(scope.row)' type=text><i class="fa fa-history" style=""></i></el-button>
              </el-tooltip>


              <el-tooltip class="item" effect="dark" :content="dfDelCt" placement="top">
                <el-button v-show="info.type === '1'"  @click='delAppPush(scope.row)' type=text><i class="fa fa-trash" style="color:#FF4949;"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
        
        <div class="gPgDiv">

          <el-pagination
          class='gPg'
          @current-change="pageSelect"
          @size-change="pageSized"
          :current-page="page"
          :page-sizes='$gRows'
          :page-size="row"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    

    <!-- head -->
    <div class='gPageBorder' >
      <div style='width:100%;height:100%;background: none;padding:0 0px 0 24px;'>
        <div style='height:64px;'>
          <button class='ldt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{info ? info.fileName : ''}}</button>
        </div>
        <div style='height:65px;'>
          <table class='ldt-file'>
            <tr style=''>
              <td>
                <label class='ldt-word-title'>{{$t('app_version')}}：</label>
                <label class='ldt-word-main'>{{info ? info.fileVersion : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_filetype')}}：</label>
                <label class='ldt-word-main'>{{info ? getftype[info.fileType] : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_subtype')}}：</label>
                <label class='ldt-word-main'>{{info ? getstype[info.subFileType] : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_distributor')}}：</label>
                <label class='ldt-word-main'>{{info ? info.mechName : ''}}</label>
              </td>
            </tr>
            <tr style=''>
              <td>
                <label class='ldt-word-title'>{{$t('app_adddate')}}：</label>
                <label class='ldt-word-main'>{{info ? info.createTime : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_fileSize')}}：</label>
                <label class='ldt-word-main'>{{info ? (info.fileSize/1024).toFixed(2) : ''}}KB</label>
              </td>
              <td colspan="2">
                <label class='ldt-word-title'>MD5：</label>
                <label class='ldt-word-main'>{{info ? info.hashCode : ''}}</label>
              </td>
              <td>
                
              </td>
            </tr>
          </table>
        </div>
        <div style='background:none;min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='ldt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_filedesc')}}：
          </div>
          <div class='ldt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;padding-right:24px;'>
            <pre>{{info ? info.memo:''}}</pre>
          </div>
        </div>

      </div>
    </div>

    <div id='' class='gPageBorder gTopMg' v-loading='loading'>

      <el-dialog class='gDia' :title="$t('app_push')" v-model="pushQs" @open=open @close='close'>
        <p>{{$t('app_ispushf') + '，' + fileName}}？</p>
        <span slot="footer" class="dialog-footer">
          <span style="margin-right:10px;" v-show="info.type === '1'">
            <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
          </span>
          <span style="margin-right:10px;" v-show="info.type === '2'">
            <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
          </span>
          <el-button @click="pushQs = false">{{$t('app_cancel')}}</el-button>
          <el-button type="primary" @click="surePush">{{$t('app_srpush')}}</el-button>
        </span>
      </el-dialog>
    
      <el-dialog class='gDia' :title="$t('app_fipush') " v-model="pushImport" @close='closeImport'>
        <el-form model="" rules="" ref="">
          <el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

            <el-upload
              class="upload-demo"
              ref="upload"
              name="fileUpload"
              :action="importTemplate"
              :on-remove="handleRemove"
              :before-upload="srcBefore"
              :on-success="srcSuccess"
              :on-error='ulError'
              :file-list="fileList"
              :auto-upload="true">
              <el-button slot="trigger" size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
              <a :href="downTpl" style="margin-left:8px;margin-right:10px;"><el-button type="success" size='small'>{{$t('terminal.list.import_muban')}}</el-button></a>
            </el-upload>

          </el-form-item>
          <el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
            {{uldata?uldata.terNums : 0 + $t('app_amechine')}}
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <span style="margin-right:10px;" v-show="info.type === '1'">
            <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
          </span>
          <span style="margin-right:10px;" v-show="info.type === '2'">
            <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
          </span>
          <el-button @click="pushImport = false">{{$t('app_cancel')}}</el-button>
          <el-button :disabled="!uldata" style="margin-left: 10px;"  type="primary" @click="submitUpload">{{$t('app_srpush')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog class='gDia' :title="$t('app_pushAll')" v-model="pushAll" @open=open @close='close'>
        <p>{{allMcName}}</p>
        <span slot="footer" class="dialog-footer">
          <span style="margin-right:10px;" v-show="info.type === '1'">
            <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
          </span>
          <span style="margin-right:10px;" v-show="info.type === '2'">
            <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
            <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
          </span>
          <el-button @click="pushAll = false">{{$t('app_cancel')}}</el-button>
          <el-button type="primary" @click="surePushAll">{{$t('app_srpush')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog class='gDia' :title="$t('app_srpush')" v-model="pushAf" @open=open @close='close'>
        <p>{{surePushTip}}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="pushAf = false">{{$t('app_cancel')}}</el-button>
          <el-button @click="coverPush('1')">{{$t('app_cvpush')}}</el-button>
          <el-button type="primary" @click="coverPush('0')">{{$t('app_skpush')}}</el-button>
        </span>
      </el-dialog>

      <el-dialog class='gDia' :title="$t('app_pssuccess')" v-model="pushDone" @open=open @close='close'>
        <p>{{$t('app_isjtoviewtd') + '?'}} </p> 
        <span slot="footer" class="dialog-footer">
          <el-button @click="pushDone = false">{{$t('app_cancel')}}</el-button>
          <el-button type="primary" @click="jumpNow">{{$t('app_nowjump')}}</el-button>
        </span>
      </el-dialog>
        


      <el-row>
        
        <el-col :span='12'>
          <el-button class='gSgLeftBtn' @click='multiBind' style=''>{{$t('app_mulPush')}} ({{sNum1}})</el-button>
          <el-button  class='gSgLeftBtn' @click='pushAll = true;' style=''>{{$t('app_allpush')}}</el-button>
          <el-button :disabled="false" class='gSgLeftBtn' @click='pushImport = true' style=''>{{$t('app_fipush')}}</el-button>
        </el-col>
      

        <el-col :span='4'>
          <div class='gCtrl'>
            
            <!-- <el-select  @change='selectChange' style='' v-model="channelId" clearable :placeholder="$t('app_distributor')">
              <el-option
                v-for="item in channels"
                :key="item.mechanismid"
                :label="item.mechanismname"
                :value="item.mechanismid">
              </el-option>
            </el-select> -->
          
            <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
          </div>
        </el-col>

        <el-col :span='4'>
          <div class='gCtrl'>
            <el-select  @change='selectStChange' style='' v-model="status" clearable :placeholder="$t('app_status')">
              <el-option
                v-for="item in stModel"
                :key="item.vl"
                :label="item.lb"
                :value="item.vl">
              </el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span='4'>
          <div class='gSideCtrl'><el-input :placeholder="$t('app_deviceNo') + '/' + $t('app_deviceName')" v-model='iNo' @keyup.enter.native='srch' icon='search' :on-icon-click='srch'></el-input></div>
        </el-col>

      </el-row>
        
      <div id=''>
        <el-table
        class='gTopMg'
        ref="multipleTable"
        :data="tableData1"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange1">
          <el-table-column
            type="selection"
            align='center'
            width="80">
          </el-table-column>
          <el-table-column
            align='center'
            prop="terminalNo"
            :label="$t('app_deviceNo')"
            width="">
          </el-table-column>
          <el-table-column
            prop="terminalName"
            align='center'
            :label="$t('app_deviceName')"
            width="">
          </el-table-column>
          <el-table-column
            prop="terminal_status"
            align='center'
            :label="$t('app_status')"
            width="90">
            <template slot-scope="scope">
              <span v-if='isNon'>
                
                <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_enable')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
              </span>
              <span v-else>
                <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
                <el-tag v-if="scope.row.terminalStatus == 4 " type="danger" size="mini">{{$t('lin_btn.lock')}}</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            prop="mechName"
            :label="$t('app_distributor')"
            width=''>
          </el-table-column>
          <el-table-column
            prop="operate"
            :label="$t('app_operate')"
            align='center'
            width='80'>
            <template slot-scope='scope'>
              <!-- <el-button  type='text' @click='bindOperate(scope.row)'>{{$t('app_push')}}</el-button> -->

              <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
                <el-button type='text' @click='bindOperate1(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class='gPgDiv'>

          <el-pagination
          class='gPg'
          @current-change="pageSelect1"
          @size-change="pageSized1"
          :current-page="index"
          :page-sizes='$gRows'
          :page-size="row"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1">
          </el-pagination>

        </div>
        
      </div>
    </div>

  </div>
</template>

<style>
  .lcpush {width:100%;}
  
  #abInfo p{height:30px;}
  #abInfo td{height:30px;background:none;}
  #abInfo{background: none;width:50%;border:1px solid #EAEEFA;border-radius:7px;height:105px;display:flex;display:-webkit-flex;overflow:hidden;}
  .diTag{background:no1ne;height:52px;width:50%;display:inline-block;}
    .diTag div{width:93%;height:100%;;background:none;display:flex;display:-webkit-flex;flex-direction:column;overflow:hidden;font-size:14px;color:#495769; text-overflow:ellipsis;white-space:nowrap;}
</style>

<script>
  import { baseurl,url,focusEvent,urlAssets } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import tyc from '@/components/global/tyc.vue'
  export default{
    data () {
      var that = this
      return {
        isNon: false,
        tqobj: '',
        getftype: '',
        getstype: '',
        batchSl:[],
        queryKey: '',
        mechanismId: window.localStorage['mechanismId'],
        tableData: [],
        info: '',
        total: 0,
        pushedList: false,
        row: this.$gRow,
        page: 1,
        list: [],
        isMarket: false,
        isAppBatch: false,
        sNum: 0,
        detail: '',
        playPlace: {
          '1': this.$t('app_on'),
          '2': this.$t('app_off'),
          '3': this.$t('app_onOff')
        },
        adType: {'1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo')},



        mechanismData: {
          callback (value, obj) {
            that.selectMcObj = obj
            that.channelId = value
            that.selectChange1(value)
          }
        },
        dvStatus: '',
        dvsts: [],
        uldata: '',
        fileList: [],
        srcList: [],
        downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
        importTemplate: `${urlAssets.prefix}tms-server-web/import/terminalList.do`,
        formLabelWidth: '28.5%',
        selectMcObj: '',
        sNum1: 0,
        resAf: '',
        check1: false,
        check2: false,
        pushQs: false,
        pushQsNo: '',
        pushAll: false,
        pushAf: false,
        pushDone: false,
        pushImport: false,
        status: '',
        iNo: '',
        selected: [],
        info: '',
        launcherBind: '',
        tableData1: [],
        multipleSelection: [],
        channels: [],
        channelId: '',
        loading: 0,
        total1: 0,
        index: 1
      }
    },
    components: {MechanismSelector,tyc},
    computed: {
      
      fileName () {
        console.log('dddd',this.info)
        switch (this.info.type) {
          case '4':
            return this.info.data.firmwareName
            break
          case '10':
            
            break
          case '6':
           
            break
          case '2':
            return this.info.data.name
            break 
          case '1':
            if (this.isAppBatch) {
              var appNames = ''
              this.info.data.forEach((vl) => {
                appNames += vl.appName + ','
              })
              appNames = appNames.substring(0, appNames.length - 1)
              return appNames
            } else {
              return this.info.data.appName
            }
            break
        }
        
      },
      surePushTip () {
        //return $t('app_ttpsddvnum') + pushAfNum + ', ' + $t('app_srsktsdv') + '?'
        return this.$t('app_psdonelftip').replace('{num}', this.pushAfNum)
      },
      pushAfNum () {
        return this.resAf? this.resAf.data.nums : ''
      },
      fileUploadUrl () {
        return `${baseurl}/terminal/importTers.do`+"?language="+localStorage.sys_lang + '&token=' + localStorage.user
//        return this.$fileExcelUlUrl
      },
      allMcName () {
        
        

        var mc = this.selectMcObj? this.selectMcObj.name : this.$t('lin_global.all_mechanism')
        var sp = "   ，"
        var str = this.$t('app_ispushalldv') + '？' + this.$t('app_distributor') + '：' + mc + sp + this.$t('app_status') + '：' + this.dvStatus[this.status] + sp + this.$t('app_deviceNum') + '：' + this.total1
       
        return str
      },
      stModel () {
        var app =''
        if (this.isNon) {
         
          app = [
            {vl:'',  lb: this.$t('lin_global.all_status')},
            {vl:'0', lb: this.$t('app_new')},
            {vl:'1', lb: this.$t('app_enable')}
          ]
        } else {
          app = this.dvsts
        }
        return app
      },
      isLauncher () {
        if (this.launcherBind) {
          return true
        } else {
          return false
        }
      },
      dfDelCt () {
        var dfstr = this.$t('app_del')
        if (this.info) {
          if (this.info.type === '1') {
            return this.$t('app_unbind')
          } else {
            return dfstr
          }
        } else {
          return dfstr
        }
      },
      cmType () {
        var type = ''
        if (this.info.type === '2') {
          type = this.detail.fileType === '0' ? this.$t('app_ttPkg') : this.$t('app_dfPkg')
        } else if(this.info.type === '4') {
          type = this.detail ? this.detail.fileType : ''
        }
        return type
      },
      avtStyle () {
        return 'background-size: cdetachIndexge: url(' + this.avt + ')'
      },
      index () {
        return this.$getWPage('appMarketPushPage')
      }
    },
    methods: {
      query () {

      },
      batchTotal (detachIndex,msl) {
				var num = 0
				this.batchSl.forEach((arr,index) => {
          if (index != detachIndex) {
            num += arr.length
          }
				})
				return num + msl.length
			},
      refreshBind () {
        this.getBinds()
      },
      surePush () {
        //this.bindOperate()
        //console.log(this.pushQsNo)
        this.pushQs = false
        this.bindRqs('0', this.pushQsNo, this.check2, this.check1)
      },
      closeImport () {
        this.fileList = []
        this.uldata = ''
      },
      handleRemove () {

      },
      ulError () {
        window[this.$route.path] = ''
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        //console.log(res, this.fileList)
        
        if (res.status === 200) {
          this.fileList = [{name: file.name}]
          this.uldata = res.data
        } else {
         
          this.srcList = []
          
          this.$message.error(res.message)
        }
      },
      srcBefore (file) {
        window[this.$route.path] = 1
      },
      submitUpload () {
        //console.log(this.uldata)
        this.bindRqs('2')
        this.pushImport = false
      },
      jumpNow () {
        this.$router.push({path: '/task/ptask'})
      },
      skipPush () {

      },
      surePushAll () {
        this.bindRqs('1', '') 
        //this.pushAll = false
      },
      surePushAf () {
        this.bindRqs('1', '') 
        //this.pushAll = false
      },
      coverPush (cvParam) {
        //console.log(this.resAf)
        
        this.loading = 1
        this.$isCoverPush(this.resAf.data.taskId, this.resAf.data.pushParam, cvParam, (res) => {    
          this.loading = 0
          if (res.status === 200) {
            this.pushAf = false
            this.pushDone = true
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.loading = 0
          this.$message.error(this.$('app_rqsError'))
        }) 
      },
      pageSelect1 (index) {
        this.fillBatchsl()

        this.index = index
       
        this.getDevices()
        
        // this.$setWPage('appMarketTerPage', index)
      },
      pageSized1 (val) {
        this.batchSl = []

        this.$gRow = val
       
        this.getDevices()
        
      },
      selectChange1 (vl) {
        
          this.getDevices()
        
      },
      selectStChange (vl) {
        
          this.getDevices()
        
      },
      srch () {
       
          this.getDevices()
        
      },
      fillBatchsl () {
        this.batchSl[this.index-1] = this.selected
      },
      handleSelectionChange1 (list) {
        this.sNum1 = this.batchTotal(this.index - 1,list)
        this.selected = list
      },
      multiBind () {
        this.fillBatchsl()

        var ids = ''
        var tNo = ''
        var tmid = ''
        // this.selected.forEach((vl) => {
          // ids += vl.terminalId + ','
          // tNo += vl.terminalNo + ','
          // tmid += vl.manufId + ','
        // })

        this.batchSl.forEach((arr) => {
          arr.forEach(vl => {
              ids += vl.terminalId + ','
              tNo += vl.terminalNo + ','
              tmid += vl.manufId + ','
          }) 
        })

        ids = ids.substring(0, ids.length - 1)
        tNo = tNo.substring(0, tNo.length - 1)
        tmid = tmid.substring(0, tmid.length - 1)
        
        
        if (!tNo) {
          this.$message(this.$t('app_oneDeviceMust'))
          return
        }
        //console.log(tNo)
        if (this.info.type === '1' || this.info.type === '2') {
          this.pushQs = true
          this.pushQsNo = tNo
        } else {
          this.bindRqs('0', tNo)
        }
        
      },
      bindRqs (pushType, tNos) {
        
        this.loading = 1
        var terNos = ''
        var mecId = ''
        var terStatus = ''
        var terNo = ''
        var flNo = ''
        var objId = ''
        var auto = this.check1 ? '1':'0'
        var install = this.check2 ? '1':'0'
        switch (pushType) {
          case '0':
            terNos = tNos
            break
          case '1':
            mecId = this.channelId ? this.channelId : ''
            terStatus = this.status ? this.status : ''
            terNo = this.iNo ? this.iNo : ''
            break
          case '2':
            flNo = this.uldata ? this.uldata.fileNo : ''
            break
        }

        switch (this.info.type) {
          case '13':
            objId = this.info.data.recordId
            break
          case '4':
          case '2':
          case '14':
          case '15':
             objId = this.info.data.id
            break
          case '10':
            objId = this.info.data.launcherid
            break
          case '6':
            objId = this.info.data.animatId
            break
          case '1':
            if (this.isMarket) {
              objId = this.info.data.applicationid
            } else {
              objId = this.info.data.appdevid
            }
            
            break
        
        }
        
        
        this.$filePush(this.info.fileId, auto, install, pushType, terNos, mecId, terStatus, terNo, flNo, (res) => {
          console.log('pushRqs', res)
          this.loading = 0
          this.check1 = false
          this.check2 = false
          if (res.status === 200) {
            this.pushAll = false
            //this.$message.success(this.$t('app_tipViewTask'))
            this.getDevices()
            this.pushDone = true
          } else if (res.status === 300) {
            this.pushAll = false
            this.pushAf = true
            this.resAf = res
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.loading = 0
          this.$message.error(this.$('app_rqsError'))
        }) 
        
        
      },
      bindOperate1 (row) {
        
        if (this.info.type === '1' || this.info.type === '2') {
          this.pushQs = true
          this.pushQsNo = row.terminalNo
          //this.bindRqs('0', row.terminalNo, this.check1, this.check2)
        } else {
          
          this.bindRqs('0', row.terminalNo)
        }
        //console.log(row, this.info.data)
      },
      getChannels () {
        this.$getChannelList(10000, 1,'', '', '', (res) => {
          if (res.status === 200) {
            this.channels = res.data
            // console.log(this.channels)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getDevices () {
        var channel = this.channelId ? this.channelId : ''
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.status ? this.status : ''
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid


        var mFileId,fileId,fileType

        switch (this.info.fileType) {
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
            // this.getDevices()
            this.isNon = false
            break
          case '6':
            this.isNon = true
            this.getNonDevices()
            return
            break
        }
       
    

        this.loading = 1
        this.$canPushTer(this.index, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.data) {
            this.total1 = res.total
            this.tableData1 = res.data

            var _this = this
            var tsl = this.batchSl[this.index - 1]
            if (tsl) {
              var tm = []
              tsl.forEach((vl) => {
                res.data.forEach((vl1) => {
                  if (vl.terminalNo == vl1.terminalNo)
                  {
                    tm.push(vl1)
                  }
                })
              })
              setTimeout(() => {
                _this.toggleSelection(tm)
              },100)
            }
          }
        }, () => {
          // error
          this.loading = 0
        })
        
        
      },
      getNonDevices () {
        var channel = this.channelId ? this.channelId : ''
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.status ? this.status : ''
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid

        // var mFileId,fileId,fileType

  
        this.loading = 1
        this.$getNonItDv(this.index, this.$gRow, channel, terminalNo, status,'', '', '','','', (res) => {
          
          this.loading = 0
          if (res.data) {
            this.tableData1 = res.data
            this.total1 = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
        
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      bind (tId, tNo, tmid) {
        // console.log(this.info)
        var vl = tId ? tId : ''
        this.loading = 1

        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid

        if (this.$appUrlTag === 0) {
          this.$bindApp('0', vl, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$bindApp1(tmid, tNo, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      mulDelAppPush () {

        var title = this.$t('app_srdelpush')
        if (this.info.type == 1) {
          title = this.$t('app_isUnbindApp')
        }

        this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           console.log(this.list)
            var tNos = ''
            var pkg = this.detail.packageName
            this.list.forEach((vl) => {
              tNos += vl.terminalNo + ','
            })
            tNos = tNos.substring(0, tNos.length - 1)
            // console.log(ids)
            if (!tNos) {
              this.$message($t('app_oneDeviceMust'))
              return 
            }
            this.appDelRqs(tNos, pkg)
        }, '')
      },
      delAppPush (row) {
        var title = this.$t('app_srdelpush')
        if (this.info.type == 1) {
          title = this.$t('app_isUnbindApp')
        }
        this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           console.log(row, this.detail)
           this.appDelRqs(row.terminalNo, this.detail.packageName)
        }, '')
      },
      appDelRqs (nos, pkg) {
        var ns = nos ? nos : ''
        var p = pkg ? pkg : ''
        this.$unbind(ns, this.info.data.appVersion, p, (res) => {
          this.loading = 0
          this.$message(res.message)
          if (res.status === 200) {
            this.getBinds()
          }
        }, () => {
          this.loading = 0
        })
      },
      updateDv (row) {
        this.loading = 1
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminialId, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds()
            }
          }, () => {
            this.loading = 0
          })
        } else {
          this.$bindApp1(this.mechanismId, row.terminalNo, cId, (res) => {
            this.loading = 0
            this.$message(res.message)
            if (res.status === 200) {
              this.getBinds()
            }
          }, () => {
            this.loading = 0
          })
        }
        
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      handleSelectionChange (list) {
        
        this.sNum = list.length
        this.list = list
      },
      allUnbind () {
        
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var tNos = ''
         
          this.list.forEach((vl) => {
            tNos += vl.terminalNo + ','
            
          })
          tNos = tNos.substring(0, tNos.length - 1)
          // console.log(ids)
          if (!tNos) {
            this.$message($t('app_oneDeviceMust'))
            return 
          }
          this.unbindReq(tNos, this.detail.packageName)
        }, '')
        
      },
      bindOperate (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           //console.log(row)
          this.unbindReq(row.terminalNo, this.detail.packageName)
        }, '')
      },
      unbindReq (tNo, pkg) {
        var t = tNo ? tNo : ''
        var p = pkg ? pkg : ''
        this.loading = 1
        this.$resetLauncher(p, t, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.getBinds()
            this.$message(res.message)
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
        
      },
      addBind () {
        ///launch-push-ter
        //this.$router.push({name: this.$t('menu.appManageSub.appBind')})
        switch (this.info.type) {
          case '4':
            this.$router.push({path: '/firmware/push/device'})
            break
          case '10':
            this.$router.push({path: '/launch-push/launch-push-ter'})
            break
          case '6':
            this.$router.push({path: '/animate-push/terminal'})
            break
          case '2':
            this.$router.push({path: '/romList/romPush/terminal'})
            break
          case '1':
            if (this.isMarket) {
              this.$router.push({path: '/appSlot/terminal-bind'})
            } else {
              this.$router.push({path: '/appList/terminalbind'})
            }
            break
        }
        
      },
      getBinds () {
        var id = this.info.fileId
        if (!id) return
        this.loading = 1
        this.$pushedTerList(this.page, this.$gRow, id, (res) => {
          this.loading = 0
          if (res.status === 200) {
            console.log(res)
            this.tableData = res.data
            this.total = res.total
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      },
      pageSelect (index) {
        this.page = index
        this.getBinds(index)
        this.$setWPage('appMarketPushPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getBinds()
      },
      getDetail () {
        return 
        
        console.log(this.info,this.info.data.applicationid)
        
        var id,type
        type = this.info.type
        switch (this.info.type) {
          case '13':
            id = this.info.data.recordId
            break
          case '4':
          case '14':
          case '15':
            id = this.info.data.id
            break
          case '10':
            id = this.info.data.launcherid
            break
          case '6':
            id = this.info.data.animatId
            break
          case '2':
            id = this.info.data.id
            break
          case '1':
            if (this.isMarket) {
              id = this.info.data.applicationid
            } else {
              id = this.info.data.appdevid
            }
            break
        }
        this.$pushFileDetail(id, type, (res) => {
          if (res.status === 200) {
            console.log(res)
            this.detail = res.data
            console.log(this.detail)
            this.abc = res.data.fileType
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        })
      }
    }, 
    mounted () { 

      this.tqobj = {
        keys: ['ftype','sftype','terminalType','terminalTypes'],
        callback: (data) => {
          this.getftype = data[0]
          this.getstype = data[1]
          this.dvStatus = data[2]
          this.dvsts = data[3]
        }
      }

      this.info = this.$getWObj().filePush

      this.getDevices()

      setTimeout(() => {
        this.getBinds()
      }, 500)
      this.getDetail()
      // this.getDevices()
      
      
    }
  }
</script>



// WEBPACK FOOTER //
// cmpush.vue?7ede10c0